import React from "react";
import { useHistory } from "react-router";
import { Button, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { OfferingGroupsListSearch } from "../../features/OfferingGroupsListSearch/OfferingGroupsListSearch";
import { OfferingGroupsListTable } from "../../features/OfferingGroupsListTable/OfferingGroupsListTable";
import { hasAccess } from "../../../../components/RolesModule/hasAccess";
import { MENU_ADMIN_OFFERING_GROUP_WRITE } from "../../../../lib/const/permissions";
import "./OfferingGroupsList.less";

export const OfferingGroupList = () => {
  const history = useHistory();

  return (
    <div className="offering-groups-list">
      <Row justify="space-between">
        <h1>Группы предложений</h1>
        {hasAccess(MENU_ADMIN_OFFERING_GROUP_WRITE) && (
          <div>
            <Button
              icon={<PlusOutlined />}
              type="primary"
              className="offering-groups-list__add-btn"
              style={{ marginRight: 20 }}
              onClick={() => {
                history.push(`/offering-groups/add-offer`);
              }}
            >
              Добавить предложение
            </Button>
            <Button
              icon={<PlusOutlined />}
              type="primary"
              className="offering-groups-list__add-btn"
              onClick={() => {
                history.push(`/offering-groups/create`);
              }}
            >
              Добавить группу
            </Button>
          </div>
        )}
      </Row>
      <OfferingGroupsListSearch />
      <OfferingGroupsListTable />
    </div>
  );
};
